import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';

import { IconComponent } from '../../../icon/icon.component';
import { BaseButtonDirective } from '../../base-button';
import type { RtPlanButtonVariant } from '../../button.types';

@Component({
  selector: 'rt-plan-button, a[rt-plan-button]',
  templateUrl: './plan-button.component.html',
  styleUrls: ['./../../styles/base.less', './plan-button.component.less'],
  // eslint-disable-next-line
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class PlanButtonComponent extends BaseButtonDirective {
  public readonly variant = input<RtPlanButtonVariant | 'tertiary'>('scale');
  public readonly hasIcon = input<boolean>(true);
}
